export type SortItem = {
    key: string;
    order: boolean | "asc" | "desc";
};

export interface Pagination {
  page: number;
  limit: number;
  search: string;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
  // Cursor-based pagination
  pageToken?: string;
  nextPageToken?: string;
  // Sorting
  key?: string;
  order?: boolean | "asc" | "desc";
}

export function defaultPagination(inLimit: number = 20): Pagination {
  return {
    page: 1,
    limit: inLimit,
    search: "",
    total: 0,
    totalPages: 0,
    hasNext: false,
    hasPrev: false,
    pageToken: undefined,
    nextPageToken: undefined,
    key: "name", // Default sort by name
    order: "asc"
  };
}

export interface PaginationResponse<T> {
  data: T;
  pagination: Pagination;
}